// import {createStore, combineReducers} from 'redux'
// import Mode from './mode/index'
import { configureStore } from '@reduxjs/toolkit';
import reducers from '../reducers/index';
// export default createStore(
//     combineReducers({
//         mode: Mode
//     })
// )

export const store = configureStore({
  reducer: reducers,
})